import React from 'react';
import styled from 'styled-components';
import { DialogTitle as MuiDialogTitle } from '@material-ui/core';

const S = {
  DialogTitle: styled(MuiDialogTitle)`
    padding: 0;
  `,
};

/**
 * DialogTitle은 Dialog 안에 표시될 제목을 담고 있는 컨테이너입니다.
 *
 * @version 1.0.0
 * @author [chayeoi](https://github.com/chayeoi)
*/

const DialogTitle = props => (
  <S.DialogTitle disableTypography {...props} />
);

export default DialogTitle;
